module.exports = __webpack_public_path__ + "static/SuisseIntl-Thin-3a4862fcf726b96f328b6f4872698cb6.woff2";